/* ============================================================
   CreationColor — BTW-toggle (vervangt T-Selector app)
   Toont prijzen incl. of excl. BTW (21%) en onthoudt de keuze.
   - Standaard: incl. BTW (b2c)  ·  excl = incl / 1,21
   - Prijzen worden server-side incl. BTW gerenderd; dit script
     rekent alleen de BEDRAG-tekstnodes om (behoudt structuur,
     geen dubbeltelling — ook bij geneste prijs-containers).
   - Wijkt automatisch zolang de T-Selector-app nog actief is.
   ============================================================ */
(function () {
  'use strict';

  var RATE = 1.21;
  var COOKIE = 'ccx_btw';
  var LABEL = { incl: 'incl. BTW', excl: 'excl. BTW' };

  /* Containers waarbinnen bedragen staan (overlap mag: idempotent).
     Aangevuld: staffelprijzen-tabel (prijslijst) + de cart-totalen
     die via de csapp-integratie worden getoond — deze bleven eerder
     buiten schot en toonden dus altijd de incl.-BTW-prijs. */
  var CONTAINERS = [
    '.cc-mini-price', '.cc-price-block', '.cc-tier-price',
    '.card-price', '.price', '.unit-price',
    '.cart-item-price', '.cart-item-total', '.cart-total-value',
    '[data-ccx-price]',
    '.prijslijst', '.variant_prijslijst',
    '.csapp-price', '.csapp-line-price', '.csapp-price-saving',
    '.csapps-cart-original-total', '.csapps-cart-total'
  ];
  /* Label-elementen (alleen tekst wisselen incl./excl.). */
  var LABEL_SELECTORS = ['.cc-mini-price-tax', '.tax-price-helper', '.ccx-tax'];

  /* NL-bedrag met centen: "3,95" of "1.234,56" (geen aantallen als "1-4"). */
  var PRICE_RE = /\d{1,3}(?:\.\d{3})*,\d{2}/g;

  var baseMap = (typeof WeakMap !== 'undefined') ? new WeakMap() : null;
  var tracked = [];           // verwerkte tekstnodes (voor herstel)
  var disabled = false;

  function getMode() {
    var m = (document.cookie.match(/(?:^|;\s*)ccx_btw=(incl|excl)/) || [])[1];
    return m === 'excl' ? 'excl' : 'incl';
  }
  function setMode(m) {
    document.cookie = COOKIE + '=' + m + ';path=/;max-age=31536000;samesite=lax';
  }

  function convertText(baseInclText, mode) {
    if (mode === 'incl') return baseInclText;
    return baseInclText.replace(PRICE_RE, function (num) {
      var val = parseFloat(num.replace(/\./g, '').replace(',', '.'));
      if (isNaN(val)) return num;
      return (val / RATE).toFixed(2).replace('.', ',');
    });
  }

  function processTextNode(node, mode) {
    var base;
    if (baseMap && baseMap.has(node)) {
      base = baseMap.get(node);
    } else {
      var v = node.nodeValue;
      PRICE_RE.lastIndex = 0;
      if (!PRICE_RE.test(v)) return;          // geen bedrag -> overslaan
      base = v;
      if (baseMap) baseMap.set(node, base);
      tracked.push(node);
    }
    var next = convertText(base, mode);
    if (node.nodeValue !== next) node.nodeValue = next;
  }

  function walkContainer(container, mode) {
    var walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, null, false);
    var n;
    while ((n = walker.nextNode())) { processTextNode(n, mode); }
  }

  var LABEL_RE = /(?:incl|excl)\.\s*BTW/gi;
  /* Wissel "incl. BTW" <-> "excl. BTW" in alle tekstnodes (ook ingebed,
     zoals "Totaalbedrag (incl. BTW)"), behalve in de toggle zelf. */
  function swapLabels(mode) {
    var target = LABEL[mode];
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!/BTW/i.test(n.nodeValue)) return NodeFilter.FILTER_REJECT;
        if (n.parentElement && (n.parentElement.closest('.ccx-vat-toggle') || n.parentElement.closest('.cc-tax-breakdown'))) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    }, false);
    var n;
    while ((n = walker.nextNode())) {
      LABEL_RE.lastIndex = 0;
      var next = n.nodeValue.replace(LABEL_RE, target);
      if (n.nodeValue !== next) n.nodeValue = next;
    }
  }

  function appActive() { return !!document.querySelector('.t-selector-option'); }

  function restore() {
    for (var i = 0; i < tracked.length; i++) {
      var b = baseMap && baseMap.get(tracked[i]);
      if (b != null) tracked[i].nodeValue = b;
    }
  }

  function disableForApp() {
    disabled = true;
    restore();
    document.documentElement.removeAttribute('data-ccx-btw');
    var mine = document.querySelector('.ccx-vat-toggle');
    if (mine) mine.style.display = 'none';
  }

  function apply() {
    if (disabled) return;
    if (appActive()) { disableForApp(); return; }
    var mode = getMode();
    var i, nodes;
    for (i = 0; i < CONTAINERS.length; i++) {
      nodes = document.querySelectorAll(CONTAINERS[i]);
      for (var j = 0; j < nodes.length; j++) { walkContainer(nodes[j], mode); }
    }
    swapLabels(mode);
    syncToggles(mode);
    document.documentElement.setAttribute('data-ccx-btw', mode);
  }

  function syncToggles(mode) {
    var inputs = document.querySelectorAll('.ccx-vat-input');
    for (var i = 0; i < inputs.length; i++) inputs[i].checked = (mode === 'incl');
  }

  function onToggle(e) {
    setMode(e.target.checked ? 'incl' : 'excl');
    apply();
  }

  function bindToggles() {
    var inputs = document.querySelectorAll('.ccx-vat-input');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].getAttribute('data-ccx-bound')) continue;
      inputs[i].setAttribute('data-ccx-bound', '1');
      inputs[i].addEventListener('change', onToggle);
    }
  }

  var pending;
  function observe() {
    if (!window.MutationObserver) return;
    var mo = new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(function () {
        if (disabled) return;
        bindToggles();
        apply();
      }, 120);
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    bindToggles();
    apply();
    observe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();